export default __webpack_public_path__ + "static/media/blockman-react-icon.ed2c7cab.png";